import { defineComponent as _defineComponent } from 'vue'
import { UserType } from '@/models/userType';
import { Location } from '@/models/location';
import { locationsService } from '@/services/locations.service';
import { Customer } from '@/models/tenant';
import TableActionButton from '@/components/tableWithActions/TableActionButton.vue';
import ConnectionStringModal from '@/components/locations/ConnectionStringModal.vue';
import TableWithActions from '@/components/tableWithActions/TableWithActions.vue';
import {
  canDownloadDataPlatform,
  hasCurrentUserPermission,
} from '@/utils/permissionUtils';
import { dataPlatformService } from '@/services/dataplatform.service';
import { downloadUrl } from '@/utils/misc';
import { modalService } from '@/library-services/modal.service';
import { dialogService } from '@/library-services/dialog.service';
import { computed, getCurrentInstance, onBeforeMount, ref } from 'vue';
import { DialogProgrammatic } from 'buefy';
import { useI18n } from '@/composables/i18n';
import LocationFormModal from '@/components/locations/LocationFormModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerLocations',
  props: {
    customer: null
  },
  setup(__props: any) {

const props = __props as {
  customer: Customer;
};



const { t } = useI18n();

const locations = ref<Location[]>([]);
const isPreparingDataPlatformDownload = ref(false);
const isLoading = ref(false);
const app = getCurrentInstance();

onBeforeMount(async () => {
  await fetchLocations();
});

async function fetchLocations() {
  isLoading.value = true;
  locations.value = await locationsService
    .get(props.customer.id)
    .finally(() => (isLoading.value = false));
}

function createLocation() {
  modalService.compositionApi.open(
    {
      component: LocationFormModal,
      props: {
        customer: props.customer,
      },
      events: {
        save: async () => await fetchLocations(),
      },
    },
    app,
  );
}

async function downloadDataPlatform() {
  isPreparingDataPlatformDownload.value = true;
  const url = await dataPlatformService
    .getInstallerUrl()
    .finally(() => (isPreparingDataPlatformDownload.value = false));
  downloadUrl(url);
}

function startEdit(location: Location) {
  modalService.compositionApi.open(
    {
      component: LocationFormModal,
      props: {
        location,
        customer: props.customer,
      },
      events: {
        save: async () => await fetchLocations(),
      },
    },
    app,
  );
}

function confirmDelete(location: Location) {
  dialogService.confirmWithPromise({
    title: t('dialog.confirm_delete_title').toString(),
    message: location.hasApiKey
      ? t('location.dialog.delete_connection_string', {
          name: location.name,
        }).toString()
      : t('confirmation.message', {
          action: t('action.delete').toString().toLowerCase(),
          entity: t('location.name').toString().toLowerCase(),
          name: location.name,
        }).toString(),
    confirmText: t('dialog.confirm_delete').toString(),
    cancelText: t('dialog.confirm_cancel').toString(),
    type: 'is-danger',
    onConfirm: async () => await deleteLocation(location.id),
  });
}

async function deleteLocation(id: number) {
  await locationsService
    .delete(id)
    .then(() => (locations.value = locations.value.filter((x) => x.id !== id)));
}

function openConnectionStringDialog(location: Location) {
  DialogProgrammatic.confirm({
    message: t('location.dialog.confirm_connection_string').toString(),
    onConfirm: () => {
      modalService.compositionApi.open(
        {
          component: ConnectionStringModal,
          canCancel: ['outside'],
          props: {
            location,
          },
        },
        app,
      );
    },
  });
}

const canManageLocations = computed((): boolean =>
  hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);

return { __sfc: true,props, t, locations, isPreparingDataPlatformDownload, isLoading, app, fetchLocations, createLocation, downloadDataPlatform, startEdit, confirmDelete, deleteLocation, openConnectionStringDialog, canManageLocations, TableActionButton, TableWithActions, canDownloadDataPlatform }
}

})